var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.href.length
    ? _c(
        "a",
        {
          directives: [
            {
              name: "lazy",
              rawName: "v-lazy:background-image",
              value: _vm.src,
              expression: "src",
              arg: "background-image"
            }
          ],
          key: _vm.src,
          staticClass: "image lazy-background-image",
          attrs: { href: _vm.href }
        },
        [_vm._t("default")],
        2
      )
    : _c(
        "div",
        {
          directives: [
            {
              name: "lazy",
              rawName: "v-lazy:background-image",
              value: _vm.src,
              expression: "src",
              arg: "background-image"
            }
          ],
          key: _vm.src,
          staticClass: "image lazy-background-image"
        },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib?{}!./scripts/vue/LazyBackgroundImage.vue?vue&type=template&id=deafd596&
// module id = 76
// module chunks = 0